<template>
  <el-dialog
    left
    title="Edit Document"
    width="455px"
    :closeOnClickModal="false"
    :closeOnPressEscape="false"
    :showClose="true"
    :visible.sync="showEditModal"
    @close="handleCancelEditDocument"
    class="addDocumentsCard"
  >
    <div class="row">
      <div class="col-6">
        <div>
          LP Entity
          <span class="required">*</span>
        </div>
        <el-select
          class="todo-dropdown-el-select"
          size="large"
          required
          placeholder="Select Company"
          v-model="data.lp_item"
          @change="changeCompany(data.lp_item)"
        >
          <el-option
            v-for="item in lpDetailsData"
            :key="item._id"
            :label="item.entity_name"
            :value="item._id"
          ></el-option>
        </el-select>
      </div>
      <div class="col-6">
        <div>Date</div>
        <input
          class="todo-form-date todo-form form-control"
          type="date"
          :value="data.date && moment.utc(data.date).format('YYYY-MM-DD')?moment.utc(data.date).format('YYYY-MM-DD'):moment.utc(new Date()).format('YYYY-MM-DD')"
          @input="data.date = moment($event.target.valueAsDate)"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div>Notes</div>
        <textarea
          placeholder="Notes"
          required="required"
          rows="4"
          cols="50"
          class="form-control"
          v-model="data.notes"
          @keyup="checkValidations"
        ></textarea>
      </div>
    </div>
    <div class="mt-3">
      <div class="row ml-0 mr-0" v-if="data.name || data.url">
        <div class="col-6 pl-0 pr-0">
          <div>Document Name</div>
        </div>
        <div class="col-6 pl-0 pr-0">
          <div style="padding-left: 5px;">
            Document Type
            <span class="required">*</span>
          </div>
        </div>
      </div>
      <div v-if="data.url">
        <div class="d-flex align-items-center fileItem my-2" style="padding-top:0px;height:45px">
          <div class="col-6 pl-0 pr-0">
            <div class="d-flex">
              <!-- <a :href="formatUrl(data.url)" target="_blank"> -->
              <span style="width: 300px;" class="attachment-name-class">{{data.url}}</span>
              <!-- </a> -->
            </div>
          </div>
          <div class="col-6 pl-0 pr-0">
            <div class="d-flex">
              <div class="col-12 pl-0">
                <el-select
                  class="todo-dropdown-el-select documents-dropdown-el-select"
                  size="small"
                  required
                  placeholder="Select Document type"
                  v-model="data.document_type"
                  @change="checkValidations"
                >
                  <el-option
                    v-for="item in vals.LP_DOCUMENT_TYPE_OPTIONS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <!-- <div class="col-2"></div> -->
            </div>
          </div>
        </div>
      </div>
      <div v-if="data.name">
        <div class="d-flex align-items-center fileItem my-2" style="padding-top:0px;height:45px">
          <div class="col-6 pl-0 pr-0">
            <div class="d-flex">
              <i
                v-if="data.name.includes('.doc') || data.name.includes('.txt')"
                class="fas fa-file-word mr-2"
                style="color:#5190FF;padding-top:3px;"
              ></i>
              <i
                v-else-if="data.name.includes('.zip') || data.name.includes('.rar')"
                class="far fa-file-archive mr-2"
                style="padding-top:3px;"
              ></i>
              <i
                v-else-if="data.name.includes('.png') || data.name.includes('.jpeg') || data.name.includes('.svg')"
                class="fas fa-image mr-2"
              ></i>
              <i
                v-else-if="data.name.includes('.csv') || data.name.includes('.xls')"
                class="fas fa-file-excel mr-2"
                style="color:#F15643;padding-top:3px;"
              ></i>
              <i
                v-else-if="data.name.includes('.pdf')"
                class="fas fa-file-pdf mr-2"
                style="color:#F15643;padding-top:3px;"
              ></i>
              <span
                style="cursor:pointer;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;flex-grow: 1;"
              >{{data.name}}</span>
            </div>
          </div>
          <div class="col-6 pl-0 pr-0">
            <div class="d-flex">
              <div class="col-12 pl-0">
                <el-select
                  class="todo-dropdown-el-select documents-dropdown-el-select"
                  size="small"
                  required
                  placeholder="Select Document type"
                  v-model="data.document_type"
                  @change="checkValidations"
                >
                  <el-option
                    v-for="item in vals.LP_DOCUMENT_TYPE_OPTIONS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <!-- <div class="col-2"></div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 d-flex" style="padding: 0px;">
      <div class="col-xl edit-company-action-button-row" style="padding:0px;">
        <button
          type="button"
          class="todo-form-cancel-button btn-outline-secondary"
          @click.prevent="handleCancelEditDocument"
        >Cancel</button>
        <button
          type="submit"
          @click.prevent="EditFiles"
          class="todo-form-submit-button btn btn-primary"
          style="height:35px;"
          :disabled="disableSave || saveDisable || showEditSpinner"
        >
          Save
          <b-spinner v-if="showEditSpinner" style="float: right;" small label="Loading..."></b-spinner>
        </button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { Dialog } from "element-ui";
import moment from "moment";
import { Select, Option } from "element-ui";
import api from "../../../axios_api";
//import { Company, patchCompany } from "../../../models/Company";
//import { vals } from "../../../util";
import { mapGetters } from "vuex";
import { vals } from "../../../util";
export default {
  name: "editLpDocumentsCard",
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    data: Object,
    lpItem: Object,
    context: String,
    isUpdate: Object,
    value: Object,
  },
  data() {
    return {
      vals,
      showEditSpinner: false,
      selectedPortfolio: {},
      saveDisable: true,
    };
  },
  computed: {
    ...mapGetters("lpAllocations", ["lpDetailsData"]),
    moment() {
      return moment;
    },
    showEditModal: {
      get() {
        return this.value.isUpdate;
      },
      set(value) {
        this.value.isUpdate = value;
      },
    },
    disableSave() {
      this.checkValidations();
      return this.saveDisable;
    },
  },
  methods: {
    handleCancelEditDocument() {
      this.showEditModal = false;
      this.showEditSpinner = false;
      this.data.document_type = "";
      this.checkValidations();
    },
    EditFiles() {
      const self = this;
      let serverData = JSON.parse(JSON.stringify(this.data));
      serverData.date = serverData.date ? serverData.date : new Date();
      serverData.notes = serverData.notes ? serverData.notes : "";
      serverData.document_id = serverData.lp_item;
      if (serverData.__v == 0) {
        delete serverData.__v;
      }
      this.showEditSpinner = true;
      api
        .patch(`/${this.$route.params.account_id}/${this.$route.params.workspace_id}/lpDocument`, {
          encrypt: {
            data: serverData,
          },
        })
        .then((data) => {
          self.handleCancelEditDocument();
          self.$emit("refresh", data);
        })
        .catch((error) => {
          console.log("error in update docs", error);
          self.$toaster.error("Failed to update.");
        });
    },
    changeCompany(companyId) {
      if (companyId) {
        this.selectedPortfolio = this.lpDetails.find((item) => {
          if (item._id == companyId) {
            return item;
          }
        });
      }
      this.checkValidations();
    },
    checkValidations() {
      if (
        this.data.lp_item &&
        this.data.lp_item.length > 0 &&
        this.data.document_type &&
        this.data.document_type.length > 0
      ) {
        this.saveDisable = false;
      } else {
        this.saveDisable = true;
      }
    },
  },
  mounted() {
    this.checkValidations();
  },
};
</script>